import { Action, History, Location, UnregisterCallback } from 'history';

export class IntercomService {
	private mHistoryChangedUnregisterCallback: UnregisterCallback;
	private mDidLaunch: boolean;

	constructor(history?: History) {
		if (!!this.available) {
			(window as any).intercomSettings = {
				alignment: 'right',
				app_id: 'ss7f5xrz',
				hide_default_launcher: true,
				horizontal_padding: 35,
				include_for_logged_out_users: true,
				vertical_padding: 100,
			};
			Intercom('boot', {
				app_id: 'ss7f5xrz',
			});

			// listen for history changes
			/**
			 * For single paged apps or pages where the URL changes without a full page reload,
			 * the Intercom Messenger does not automatically send URL changes to Intercom to match messages based on URLs.
			 * You will need to call Intercom("update") in order to initiate a "ping" every time a URL changes.
			 * @see https://www.intercom.com/help/install-on-your-product-or-site/other-ways-to-get-started/integrate-intercom-in-a-single-page-app
			 */
			this.mHistoryChangedUnregisterCallback = !!history ? history.listen(this.onHistoryChanged) : null;

			this.mDidLaunch = true;
		}
	}

	public get available() {
		return !!!!window && !!window.hasOwnProperty('Intercom');
	}

	public get didLaunch() {
		return !!this.available && !!this.mDidLaunch;
	}

	public showMessenger = () => {
		if (!!this.available) {
			Intercom('show');
		}
	}

	public hideMessenger = () => {
		if (!!this.available) {
			Intercom('hide');
		}
	}

	public dispose = () => {
		if (!!this.available) {
			Intercom('shutdown');
		}

		if (!!this.mHistoryChangedUnregisterCallback) {
			this.mHistoryChangedUnregisterCallback();
			this.mHistoryChangedUnregisterCallback = null;
		}
	}

	private onHistoryChanged = (_: Location, __: Action) => {
		if (!!this.available) {
			Intercom('update');
		}
	}
}

export const InitIntercomService = (history?: History) => {
	if (!!window) {
		const service = new IntercomService(history);
		(window as any).__LevitateIntercomService = service;
		return service;
	}

	return null;
};
